function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function () { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function (obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function (skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function () { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function (exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function (type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function (record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function (finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function (tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function (iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { default as At } from "./electronESM.js";
var ke = "highlight.run",
    Se = "5.1.3",
    Ee = {
  build: "yarn typegen && rollup -c",
  dev: "doppler run -- rollup -c -w",
  "enforce-size": "bundlesize",
  test: "vitest",
  typegen: "tsc"
},
    Ne = "dist/index.js",
    _e = "dist/indexESM.js",
    Te = "dist/src/index.d.ts",
    xe = "MIT",
    Le = {
  "@rollup/plugin-commonjs": "^22.0.1",
  "@rollup/plugin-json": "^4.1.0",
  "@rollup/plugin-node-resolve": "^13.3.0",
  "@rollup/plugin-replace": "^4.0.0",
  "@types/chrome": "^0.0.144",
  bundlesize: "^0.18.1",
  esbuild: "^0.14.47",
  rollup: "^2.75.7",
  "rollup-plugin-consts": "^1.1.0",
  "rollup-plugin-esbuild": "^4.9.1",
  "rollup-plugin-filesize": "^9.1.2",
  "rollup-plugin-web-worker-loader": "^1.6.1",
  tslib: "^2.4.0",
  typescript: "^4.0.3",
  vitest: "^0.23.4"
},
    Ie = [{
  path: "dist/**.js",
  maxSize: "20 kB"
}],
    q = {
  name: ke,
  version: Se,
  scripts: Ee,
  main: Ne,
  module: _e,
  types: Te,
  license: xe,
  devDependencies: Le,
  bundlesize: Ie
};

const He = () => {
  var t, e;
  typeof chrome != "undefined" && ((t = chrome == null ? void 0 : chrome.runtime) == null ? void 0 : t.onMessage) && ((e = chrome == null ? void 0 : chrome.runtime) == null || e.onMessage.addListener((r, o, a) => {
    const c = r.action;

    switch (console.log("[highlight] received '".concat(c, "' event from extension.")), c) {
      case "init":
        {
          const s = "http://localhost:8080/dist/index.js";
          console.log("url", s), y.init(1, {
            debug: !0,
            scriptUrl: s
          }), y.getSessionURL().then(i => {
            a({
              url: i
            });
          });
          break;
        }

      case "stop":
        {
          y.stop(), a({
            success: !0
          });
          break;
        }
    }

    return !0;
  }));
},
      Pe = _ref => {
  let t = _ref.apiKey;

  (function (e, r) {
    var o = e.amplitude || {
      _q: [],
      _iq: {}
    },
        a = r.createElement("script");
    a.type = "text/javascript", a.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", a.crossOrigin = "anonymous", a.async = !0, a.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", a.onload = function () {
      e.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(t);
    };
    var c = r.getElementsByTagName("script")[0];
    c.parentNode.insertBefore(a, c);

    function s(p, m) {
      p.prototype[m] = function () {
        return this._q.push([m].concat(Array.prototype.slice.call(arguments, 0))), this;
      };
    }

    for (var i = function () {
      return this._q = [], this;
    }, n = ["add", "append", "clearAll", "prepend", "set", "setOnce", "unset", "preInsert", "postInsert", "remove"], u = 0; u < n.length; u++) s(i, n[u]);

    o.Identify = i;

    for (var l = function () {
      return this._q = [], this;
    }, d = ["setProductId", "setQuantity", "setPrice", "setRevenueType", "setEventProperties"], f = 0; f < d.length; f++) s(l, d[f]);

    o.Revenue = l;
    var g = ["init", "logEvent", "logRevenue", "setUserId", "setUserProperties", "setOptOut", "setVersionName", "setDomain", "setDeviceId", "enableTracking", "setGlobalUserProperties", "identify", "clearUserProperties", "setGroup", "logRevenueV2", "regenerateDeviceId", "groupIdentify", "onInit", "logEventWithTimestamp", "logEventWithGroups", "setSessionId", "resetSessionId"];

    function h(p) {
      function m(b) {
        p[b] = function () {
          p._q.push([b].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }

      for (var w = 0; w < g.length; w++) m(g[w]);
    }

    h(o), o.getInstance = function (p) {
      return p = (!p || p.length === 0 ? "$default_instance" : p).toLowerCase(), Object.prototype.hasOwnProperty.call(o._iq, p) || (o._iq[p] = {
        _q: []
      }, h(o._iq[p])), o._iq[p];
    }, e.amplitude = o;
  })(window, document);
},
      Ce = _ref2 => {
  let t = _ref2.projectToken;

  (function (r, o) {
    if (!o.__SV) {
      var a, c;
      window.mixpanel = o, o._i = [], o.init = function (s, i, n) {
        function u(f, g) {
          var h = g.split(".");
          h.length == 2 && (f = f[h[0]], g = h[1]), f[g] = function () {
            f.push([g].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }

        var l = o;

        for (typeof n != "undefined" ? l = o[n] = [] : n = "mixpanel", l.people = l.people || [], l.toString = function (f) {
          var g = "mixpanel";
          return n !== "mixpanel" && (g += "." + n), f || (g += " (stub)"), g;
        }, l.people.toString = function () {
          return l.toString(1) + ".people (stub)";
        }, a = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" "), c = 0; c < a.length; c++) u(l, a[c]);

        var d = "set set_once union unset remove delete".split(" ");
        l.get_group = function () {
          function f(m) {
            g[m] = function () {
              call2_args = arguments, call2 = [m].concat(Array.prototype.slice.call(call2_args, 0)), l.push([h, call2]);
            };
          }

          for (var g = {}, h = ["get_group"].concat(Array.prototype.slice.call(arguments, 0)), p = 0; p < d.length; p++) f(d[p]);

          return g;
        }, o._i.push([s, i, n]);
      }, o.__SV = 1.2;
    }
  })(document, window.mixpanel || []);

  const e = document.createElement("script");
  e.src = $e, document.head.appendChild(e), e.addEventListener("load", () => {
    var r;
    (r = window.mixpanel) == null || r.init(t);
  });
},
      $e = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js",
      je = () => {
  typeof window == "undefined" || typeof document == "undefined" || (window._originalFetch = window.fetch, window._fetchProxy = (t, e) => window._originalFetch(t, e), window._highlightFetchPatch = (t, e) => window._fetchProxy.call(window || global, t, e), window.fetch = window._highlightFetchPatch);
},
      De = () => {
  var t;
  const e = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var r = "";
  const o = typeof window != "undefined" && ((t = window.crypto) == null ? void 0 : t.getRandomValues),
        a = new Uint32Array(28);
  o && window.crypto.getRandomValues(a);

  for (let c = 0; c < 28; c++) o ? r += e.charAt(a[c] % e.length) : r += e.charAt(Math.floor(Math.random() * e.length));

  return r;
};

function Ae(t, e, r) {
  try {
    if (!(e in t)) return () => {};
    const o = t[e],
          a = r(o);
    return typeof a == "function" && (a.prototype = a.prototype || {}, Object.defineProperties(a, {
      __rrweb_original__: {
        enumerable: !1,
        value: o
      }
    })), t[e] = a, () => {
      t[e] = o;
    };
  } catch (o) {
    return () => {};
  }
}

function qe(t) {
  if (!t || !t.outerHTML) return "";
  let e = "";

  for (; t.parentElement;) {
    let r = t.localName;
    if (!r) break;
    r = r.toLowerCase();
    let o = t.parentElement,
        a = [];
    if (o.children && o.children.length > 0) for (let c = 0; c < o.children.length; c++) {
      let s = o.children[c];
      s.localName && s.localName.toLowerCase && s.localName.toLowerCase() === r && a.push(s);
    }
    a.length > 1 && (r += ":eq(" + a.indexOf(t) + ")"), e = r + (e ? ">" + e : ""), t = o;
  }

  return e;
}

function L(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}

function U(t, e) {
  if (e === 0) return !0;
  const r = Object.keys(t);

  for (const o of r) if (L(t[o]) && U(t[o], e - 1)) return !0;

  return !1;
}

function B(t, e) {
  const r = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(r, e);
  const o = [],
        a = [];
  return JSON.stringify(t, function (i, n) {
    if (o.length > 0) {
      const u = o.indexOf(this);
      ~u ? o.splice(u + 1) : o.push(this), ~u ? a.splice(u, 1 / 0, i) : a.push(i), ~o.indexOf(n) && (o[0] === n ? n = "[Circular ~]" : n = "[Circular ~." + a.slice(0, o.indexOf(n)).join(".") + "]");
    } else o.push(n);

    if (n == null) return n;
    if (c(n)) return s(n);

    if (n instanceof Event) {
      const u = {};

      for (const l in n) {
        const d = n[l];
        Array.isArray(d) ? u[l] = qe(d.length ? d[0] : null) : u[l] = d;
      }

      return u;
    } else {
      if (n instanceof Node) return n instanceof HTMLElement ? n ? n.outerHTML : "" : n.nodeName;
      if (n instanceof Error) return n.name + ": " + n.message;
    }

    return n;
  });

  function c(i) {
    return L(i) && Object.keys(i).length > r.numOfKeysLimit || typeof i == "function" ? !0 : i instanceof Event && i.isTrusted === !1 ? Object.keys(i).length === 1 : !!(L(i) && U(i, r.depthOfLimit));
  }

  function s(i) {
    let n = i.toString();
    return r.stringLengthLimit && n.length > r.stringLengthLimit && (n = "".concat(n.slice(0, r.stringLengthLimit), "...")), n;
  }
}

var M = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {},
    F = {
  exports: {}
},
    I = {
  exports: {}
},
    z;

function Ue() {
  return z || (z = 1, function (t, e) {
    (function (r, o) {
      t.exports = o();
    })(M, function () {
      function r(p) {
        return !isNaN(parseFloat(p)) && isFinite(p);
      }

      function o(p) {
        return p.charAt(0).toUpperCase() + p.substring(1);
      }

      function a(p) {
        return function () {
          return this[p];
        };
      }

      var c = ["isConstructor", "isEval", "isNative", "isToplevel"],
          s = ["columnNumber", "lineNumber"],
          i = ["fileName", "functionName", "source"],
          n = ["args"],
          u = ["evalOrigin"],
          l = c.concat(s, i, n, u);

      function d(p) {
        if (!!p) for (var m = 0; m < l.length; m++) p[l[m]] !== void 0 && this["set" + o(l[m])](p[l[m]]);
      }

      d.prototype = {
        getArgs: function () {
          return this.args;
        },
        setArgs: function (p) {
          if (Object.prototype.toString.call(p) !== "[object Array]") throw new TypeError("Args must be an Array");
          this.args = p;
        },
        getEvalOrigin: function () {
          return this.evalOrigin;
        },
        setEvalOrigin: function (p) {
          if (p instanceof d) this.evalOrigin = p;else if (p instanceof Object) this.evalOrigin = new d(p);else throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function () {
          var p = this.getFileName() || "",
              m = this.getLineNumber() || "",
              w = this.getColumnNumber() || "",
              b = this.getFunctionName() || "";
          return this.getIsEval() ? p ? "[eval] (" + p + ":" + m + ":" + w + ")" : "[eval]:" + m + ":" + w : b ? b + " (" + p + ":" + m + ":" + w + ")" : p + ":" + m + ":" + w;
        }
      }, d.fromString = function (m) {
        var w = m.indexOf("("),
            b = m.lastIndexOf(")"),
            T = m.substring(0, w),
            ye = m.substring(w + 1, b).split(","),
            A = m.substring(b + 1);
        if (A.indexOf("@") === 0) var x = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(A, ""),
            be = x[1],
            Re = x[2],
            Oe = x[3];
        return new d({
          functionName: T,
          args: ye || void 0,
          fileName: be,
          lineNumber: Re || void 0,
          columnNumber: Oe || void 0
        });
      };

      for (var f = 0; f < c.length; f++) d.prototype["get" + o(c[f])] = a(c[f]), d.prototype["set" + o(c[f])] = function (p) {
        return function (m) {
          this[p] = Boolean(m);
        };
      }(c[f]);

      for (var g = 0; g < s.length; g++) d.prototype["get" + o(s[g])] = a(s[g]), d.prototype["set" + o(s[g])] = function (p) {
        return function (m) {
          if (!r(m)) throw new TypeError(p + " must be a Number");
          this[p] = Number(m);
        };
      }(s[g]);

      for (var h = 0; h < i.length; h++) d.prototype["get" + o(i[h])] = a(i[h]), d.prototype["set" + o(i[h])] = function (p) {
        return function (m) {
          this[p] = String(m);
        };
      }(i[h]);

      return d;
    });
  }(I)), I.exports;
}

(function (t, e) {
  (function (r, o) {
    t.exports = o(Ue());
  })(M, function (o) {
    var a = /(^|@)\S+:\d+/,
        c = /^\s*at .*(\S+:\d+|\(native\))/m,
        s = /^(eval@)?(\[native code])?$/;
    return {
      parse: function (n) {
        if (typeof n.stacktrace != "undefined" || typeof n["opera#sourceloc"] != "undefined") return this.parseOpera(n);
        if (n.stack && n.stack.match(c)) return this.parseV8OrIE(n);
        if (n.stack) return this.parseFFOrSafari(n);
        throw new Error("Cannot parse given Error object");
      },
      extractLocation: function (n) {
        if (n.indexOf(":") === -1) return [n];
        var u = /(.+?)(?::(\d+))?(?::(\d+))?$/,
            l = u.exec(n.replace(/[()]/g, ""));
        return [l[1], l[2] || void 0, l[3] || void 0];
      },
      parseV8OrIE: function (n) {
        var u = n.stack.split("\n").filter(function (l) {
          return !!l.match(c);
        }, this);
        return u.map(function (l) {
          l.indexOf("(eval ") > -1 && (l = l.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var d = l.replace(/^\s+/, "").replace(/\(eval code/g, "("),
              f = d.match(/ (\((.+):(\d+):(\d+)\)$)/);
          d = f ? d.replace(f[0], "") : d;
          var g = d.split(/\s+/).slice(1),
              h = this.extractLocation(f ? f[1] : g.pop()),
              p = g.join(" ") || void 0,
              m = ["eval", "<anonymous>"].indexOf(h[0]) > -1 ? void 0 : h[0];
          return new o({
            functionName: p,
            fileName: m,
            lineNumber: h[1],
            columnNumber: h[2],
            source: l
          });
        }, this);
      },
      parseFFOrSafari: function (n) {
        var u = n.stack.split("\n").filter(function (l) {
          return !l.match(s);
        }, this);
        return u.map(function (l) {
          if (l.indexOf(" > eval") > -1 && (l = l.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), l.indexOf("@") === -1 && l.indexOf(":") === -1) return new o({
            functionName: l
          });
          var d = /((.*".+"[^@]*)?[^@]*)(?:@)/,
              f = l.match(d),
              g = f && f[1] ? f[1] : void 0,
              h = this.extractLocation(l.replace(d, ""));
          return new o({
            functionName: g,
            fileName: h[0],
            lineNumber: h[1],
            columnNumber: h[2],
            source: l
          });
        }, this);
      },
      parseOpera: function (n) {
        return !n.stacktrace || n.message.indexOf("\n") > -1 && n.message.split("\n").length > n.stacktrace.split("\n").length ? this.parseOpera9(n) : n.stack ? this.parseOpera11(n) : this.parseOpera10(n);
      },
      parseOpera9: function (n) {
        for (var u = /Line (\d+).*script (?:in )?(\S+)/i, l = n.message.split("\n"), d = [], f = 2, g = l.length; f < g; f += 2) {
          var h = u.exec(l[f]);
          h && d.push(new o({
            fileName: h[2],
            lineNumber: h[1],
            source: l[f]
          }));
        }

        return d;
      },
      parseOpera10: function (n) {
        for (var u = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, l = n.stacktrace.split("\n"), d = [], f = 0, g = l.length; f < g; f += 2) {
          var h = u.exec(l[f]);
          h && d.push(new o({
            functionName: h[3] || void 0,
            fileName: h[2],
            lineNumber: h[1],
            source: l[f]
          }));
        }

        return d;
      },
      parseOpera11: function (n) {
        var u = n.stack.split("\n").filter(function (l) {
          return !!l.match(a) && !l.match(/^Error created at/);
        }, this);
        return u.map(function (l) {
          var d = l.split("@"),
              f = this.extractLocation(d.pop()),
              g = d.shift() || "",
              h = g.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0,
              p;
          g.match(/\(([^)]*)\)/) && (p = g.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var m = p === void 0 || p === "[arguments not available]" ? void 0 : p.split(",");
          return new o({
            functionName: h,
            args: m,
            fileName: f[0],
            lineNumber: f[1],
            columnNumber: f[2],
            source: l
          });
        }, this);
      }
    };
  });
})(F);

var H = F.exports;

function Be(t, e) {
  const r = e.logger;
  if (!r) return () => {};
  let o;
  typeof r == "string" ? o = window[r] : o = r;
  const a = [];

  if (e.level.includes("error") && window) {
    const s = i => {
      const n = i.message,
            u = i.error;
      let l = [];
      u && (l = H.parse(u));
      const d = [B(n, e.stringifyOptions)];
      t({
        type: "Error",
        trace: l.slice(1),
        time: Date.now(),
        value: d
      });
    };

    window.addEventListener("error", s), a.push(() => {
      window && window.removeEventListener("error", s);
    });
  }

  for (const s of e.level) a.push(c(o, s));

  return () => {
    a.forEach(s => s());
  };

  function c(s, i) {
    var _this = this;

    return s[i] ? Ae(s, i, n => function () {
      for (var _len = arguments.length, u = new Array(_len), _key = 0; _key < _len; _key++) {
        u[_key] = arguments[_key];
      }

      n.apply(_this, u);

      try {
        const l = H.parse(new Error()),
              d = u.map(f => B(f, e.stringifyOptions));
        t({
          type: i,
          trace: l.slice(1),
          value: d,
          time: Date.now()
        });
      } catch (l) {
        n("highlight logger error:", l, ...u);
      }
    }) : () => {};
  }
}

var P = {
  exports: {}
};

(function (t, e) {
  e = t.exports = r, e.getSerialize = o;

  function r(a, c, s, i) {
    return JSON.stringify(a, o(c, i), s);
  }

  function o(a, c) {
    var s = [],
        i = [];
    return c == null && (c = function (n, u) {
      return s[0] === u ? "[Circular ~]" : "[Circular ~." + i.slice(0, s.indexOf(u)).join(".") + "]";
    }), function (n, u) {
      if (s.length > 0) {
        var l = s.indexOf(this);
        ~l ? s.splice(l + 1) : s.push(this), ~l ? i.splice(l, 1 / 0, n) : i.push(n), ~s.indexOf(u) && (u = c.call(this, n, u));
      } else s.push(u);

      return a == null ? u : a.call(this, n, u);
    };
  }
})(P, P.exports);

var K = P.exports;

const Me = t => {
  const e = window.onerror;
  return window.onerror = (r, o, a, c, s) => {
    var i, n, u, l;

    if (s) {
      let d = [];

      try {
        d = H.parse(s);
      } catch (g) {}

      const f = Fe(d);
      t({
        event: K(r),
        type: "window.onerror",
        url: window.location.href,
        source: o || "",
        lineNumber: (i = f[0]) != null && i.lineNumber ? (n = f[0]) == null ? void 0 : n.lineNumber : 0,
        columnNumber: (u = f[0]) != null && u.columnNumber ? (l = f[0]) == null ? void 0 : l.columnNumber : 0,
        stackTrace: f,
        timestamp: new Date().toISOString()
      });
    }
  }, () => {
    window.onerror = e;
  };
},
      Fe = t => {
  var e;
  if (t.length === 0) return t;
  const r = t[0];
  return r.functionName === "console.error" && ((e = r.fileName) == null ? void 0 : e.includes("highlight.run")) ? t.slice(1) : t;
},
      ze = ["assert", "count", "countReset", "debug", "dir", "dirxml", "error", "group", "groupCollapsed", "groupEnd", "info", "log", "table", "time", "timeEnd", "timeLog", "trace", "warn"];

var Ke = (t => (t.DeviceMemory = "DeviceMemory", t.ViewportHeight = "ViewportHeight", t.ViewportWidth = "ViewportWidth", t.ViewportArea = "ViewportArea", t))(Ke || {}),
    Ve = (t => (t.Device = "Device", t.WebVital = "WebVital", t.Frontend = "Frontend", t.Backend = "Backend", t))(Ve || {});

const Ge = ['["\\"Script error.\\""]', '[{"isTrusted":true}]', '["{}"]', '[""]', '["\\"\\""]'],
      We = ["websocket error", '\\"ResizeObserver loop'];

var Je = Object.defineProperty,
    Xe = Object.defineProperties,
    Ye = Object.getOwnPropertyDescriptors,
    V = Object.getOwnPropertySymbols,
    Qe = Object.prototype.hasOwnProperty,
    Ze = Object.prototype.propertyIsEnumerable,
    G = (t, e, r) => e in t ? Je(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r,
    C = (t, e) => {
  for (var r in e || (e = {})) Qe.call(e, r) && G(t, r, e[r]);

  if (V) for (var r of V(e)) Ze.call(e, r) && G(t, r, e[r]);
  return t;
},
    W = (t, e) => Xe(t, Ye(e));

const et = (t, e, r) => {
  const o = J(e, t.headers, r);
  return W(C({}, t), {
    headers: o
  });
},
      tt = (t, e, r) => {
  const o = J(e, t.headers, r);
  return W(C({}, t), {
    headers: o
  });
},
      J = (t, e, r) => {
  var o, a;
  const c = C({}, e);
  return r ? ((o = Object.keys(c)) == null || o.forEach(s => {
    [...r].includes(s == null ? void 0 : s.toLowerCase()) || (c[s] = "[REDACTED]");
  }), c) : ((a = Object.keys(c)) == null || a.forEach(s => {
    [...rt, ...t].includes(s == null ? void 0 : s.toLowerCase()) && (c[s] = "[REDACTED]");
  }), c);
},
      rt = ["authorization", "cookie", "proxy-authorization", "token"],
      nt = ["https://www.googleapis.com/identitytoolkit", "https://securetoken.googleapis.com"];

var X = void 0;

const Y = "X-Highlight-Request",
      Q = t => {
  let e = t;
  return !t.startsWith("https://") && !t.startsWith("http://") && (e = "".concat(window.location.origin).concat(e)), e.replace(/\/+$/, "");
},
      Z = (t, e, r) => {
  t.sort((i, n) => i.responseEnd - n.responseEnd);
  const o = {
    xmlhttprequest: {},
    others: {},
    fetch: {}
  },
        a = t.reduce((i, n) => {
    const u = Q(n.name);
    return n.initiatorType === r ? i[r][u] = [...(i[r][u] || []), n] : i.others[u] = [...(i.others[u] || []), n], i;
  }, o);
  let c = {};
  c = e.reduce((i, n) => {
    const u = Q(n.request.url);
    return i[u] = [...(i[u] || []), n], i;
  }, c);

  for (let i in a[r]) {
    const n = a[r][i],
          u = c[i];
    if (!u) continue;
    const l = Math.max(n.length - u.length, 0);

    for (let d = l; d < n.length; d++) n[d] && (n[d].requestResponsePair = u[d - l]);
  }

  let s = [];

  for (let i in a) for (let n in a[i]) s = s.concat(a[i][n]);

  return s.sort((i, n) => i.fetchStart - n.fetchStart).map(i => (i.toJSON = function () {
    return {
      initiatorType: this.initiatorType,
      startTime: this.startTime,
      responseEnd: this.responseEnd,
      name: this.name,
      transferSize: this.transferSize,
      encodedBodySize: this.encodedBodySize,
      requestResponsePairs: this.requestResponsePair
    };
  }, i));
},
      ot = (t, e) => {
  var r;
  return t.toLocaleLowerCase().includes((r = X) != null ? r : "highlight.run") || t.toLocaleLowerCase().includes("highlight.run") || t.toLocaleLowerCase().includes(e);
},
      $ = (t, e, r) => !ot(t, e) || j(t, r),
      j = (t, e) => {
  var r;
  let o = [];
  e === !0 ? (o = ["localhost", /^\//], (r = window == null ? void 0 : window.location) != null && r.host && o.push(window.location.host)) : e instanceof Array && (o = e);
  let a = !1;
  return o.forEach(c => {
    t.match(c) && (a = !0);
  }), a;
};

function it(t) {
  for (var e = "", r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", o = r.length, a = 0; a < t; a++) e += r.charAt(Math.floor(Math.random() * o));

  return e;
}

const ee = () => it(10),
      te = (t, e) => t + "/" + e;

var re = (t, e, r) => new Promise((o, a) => {
  var c = n => {
    try {
      i(r.next(n));
    } catch (u) {
      a(u);
    }
  },
      s = n => {
    try {
      i(r.throw(n));
    } catch (u) {
      a(u);
    }
  },
      i = n => n.done ? o(n.value) : Promise.resolve(n.value).then(c, s);

  i((r = r.apply(t, e)).next());
});

const st = (t, e, r, o, a, c) => {
  const s = XMLHttpRequest.prototype,
        i = s.open,
        n = s.send,
        u = s.setRequestHeader;
  return s.open = function (l, d) {
    return this._method = l, this._url = d, this._requestHeaders = {}, this._shouldRecordHeaderAndBody = !o.some(f => d.toLowerCase().includes(f)), i.apply(this, arguments);
  }, s.setRequestHeader = function (l, d) {
    return this._requestHeaders[l] = d, u.apply(this, arguments);
  }, s.send = function (l) {
    if (!$(this._url, e, r)) return n.apply(this, arguments);
    const d = ee();
    j(this._url, r) && this.setRequestHeader(Y, te(a, d));
    const f = this._shouldRecordHeaderAndBody,
          g = {
      id: d,
      url: this._url,
      verb: this._method,
      headers: f ? this._requestHeaders : {},
      body: void 0
    };

    if (f && l) {
      const h = ne(l, g.url);
      h && (g.body = O(h, c));
    }

    return this.addEventListener("load", function () {
      return re(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var h, w, p, m, b;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              h = {
                status: this.status,
                headers: {},
                body: void 0
              };

              if (!f) {
                _context.next = 17;
                break;
              }

              if (l) {
                w = ne(l, g.url);
                w && (g.body = O(w, c));
              }

              p = this.getAllResponseHeaders().trim().split(/[\r\n]+/), m = {};

              if (!(p.forEach(function (w) {
                const b = w.split(": "),
                      T = b.shift();
                m[T] = b.join(": ");
              }), h.headers = m, this.responseType === "" || this.responseType === "text")) {
                _context.next = 8;
                break;
              }

              h.body = O(this.responseText, c), h.size = this.responseText.length * 8;
              _context.next = 17;
              break;

            case 8:
              if (!(this.responseType === "blob")) {
                _context.next = 16;
                break;
              }

              w = this.response;
              _context.next = 12;
              return w.text();

            case 12:
              b = _context.sent;
              h.body = O(b, c), h.size = w.size;
              _context.next = 17;
              break;

            case 16:
              try {
                h.body = O(this.response, c);
              } catch (w) {}

            case 17:
              t({
                request: g,
                response: h,
                urlBlocked: !f
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }), this.addEventListener("error", function () {
      return re(this, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var h;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              h = {
                status: this.status,
                headers: void 0,
                body: void 0
              };
              t({
                request: g,
                response: h,
                urlBlocked: !1
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }), n.apply(this, arguments);
  }, () => {
    s.open = i, s.send = n, s.setRequestHeader = u;
  };
},
      ne = (t, e) => {
  if (typeof t == "string") {
    if (!(((e == null ? void 0 : e.includes("localhost")) || (e == null ? void 0 : e.includes("highlight.run"))) && t.includes("pushPayload"))) return t;
  } else if (typeof t == "object" || typeof t == "number" || typeof t == "boolean") return t.toString();

  return null;
},
      O = (t, e) => {
  if (!e || !t) return t;

  try {
    const r = JSON.parse(t);
    return Object.keys(r).forEach(o => {
      e.includes(o.toLocaleLowerCase()) || (r[o] = "[REDACTED]");
    }), JSON.stringify(r);
  } catch (r) {}

  return t;
};

var at = Object.defineProperty,
    lt = Object.defineProperties,
    ct = Object.getOwnPropertyDescriptors,
    oe = Object.getOwnPropertySymbols,
    ut = Object.prototype.hasOwnProperty,
    dt = Object.prototype.propertyIsEnumerable,
    ie = (t, e, r) => e in t ? at(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r,
    se = (t, e) => {
  for (var r in e || (e = {})) ut.call(e, r) && ie(t, r, e[r]);

  if (oe) for (var r of oe(e)) dt.call(e, r) && ie(t, r, e[r]);
  return t;
},
    ae = (t, e) => lt(t, ct(e)),
    pt = (t, e, r) => new Promise((o, a) => {
  var c = n => {
    try {
      i(r.next(n));
    } catch (u) {
      a(u);
    }
  },
      s = n => {
    try {
      i(r.throw(n));
    } catch (u) {
      a(u);
    }
  },
      i = n => n.done ? o(n.value) : Promise.resolve(n.value).then(c, s);

  i((r = r.apply(t, e)).next());
});

const ft = (t, e, r, o, a, c) => {
  const s = window._fetchProxy;
  return window._fetchProxy = function (i, n) {
    const _ht = ht(i, n),
          u = _ht.method,
          l = _ht.url;

    if (!$(l, e, r)) return s.call(this, i, n);
    const d = ee();

    if (j(l, r)) {
      n = n || {};
      let p = new Headers(n.headers);
      p.set(Y, te(a, d)), n.headers = Object.fromEntries(p.entries());
    }

    const f = {
      id: d,
      headers: {},
      body: void 0,
      url: l,
      verb: u
    },
          g = !o.some(p => l.toLowerCase().includes(p));
    g && (f.headers = Object.fromEntries(new Headers(n == null ? void 0 : n.headers).entries()), f.body = O(n == null ? void 0 : n.body, c));
    let h = s.call(this, i, n);
    return gt(h, f, t, g, c), h;
  }, () => {
    window._fetchProxy = s;
  };
},
      ht = (t, e) => {
  const r = e && e.method || typeof t == "object" && "method" in t && t.method || "GET";
  let o;
  return typeof t == "object" ? "url" in t && t.url ? o = t.url : o = t.toString() : o = t, {
    method: r,
    url: o
  };
},
      gt = (t, e, r, o, a) => {
  const c = s => pt(void 0, null, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var i, n, u, l, d, f, g, h, p;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          i = {
            body: void 0,
            headers: void 0,
            status: 0,
            size: 0
          }, n = !1;

          if (!("stack" in s || s instanceof Error)) {
            _context3.next = 5;
            break;
          }

          i = ae(se({}, i), {
            body: s.message,
            status: 0,
            size: void 0
          }), n = !0;
          _context3.next = 29;
          break;

        case 5:
          if (!("status" in s)) {
            _context3.next = 29;
            break;
          }

          if (!(i = ae(se({}, i), {
            status: s.status
          }), o)) {
            _context3.next = 28;
            break;
          }

          _context3.prev = 7;
          l = s.clone().body;

          if (!l) {
            _context3.next = 21;
            break;
          }

          d = l.getReader(), f = new TextDecoder(), h = "";

        case 11:
          _context3.next = 13;
          return d.read();

        case 13:
          if ((g = _context3.sent).done) {
            _context3.next = 18;
            break;
          }

          p = g.value;
          h += f.decode(p);

        case 16:
          _context3.next = 11;
          break;

        case 18:
          u = h, u = O(u, a);
          _context3.next = 22;
          break;

        case 21:
          u = "";

        case 22:
          _context3.next = 27;
          break;

        case 24:
          _context3.prev = 24;
          _context3.t0 = _context3["catch"](7);
          u = "Unable to clone response: ".concat(_context3.t0);

        case 27:
          i.body = u, i.headers = Object.fromEntries(s.headers.entries()), i.size = u.length * 8;

        case 28:
          n = !0;

        case 29:
          n && r({
            request: e,
            response: i,
            urlBlocked: !o
          });

        case 30:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[7, 24]]);
  }));

  t.then(c).catch(() => {});
};

var mt = Object.defineProperty,
    S = Object.getOwnPropertySymbols,
    le = Object.prototype.hasOwnProperty,
    ce = Object.prototype.propertyIsEnumerable,
    ue = (t, e, r) => e in t ? mt(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r,
    vt = (t, e) => {
  for (var r in e || (e = {})) le.call(e, r) && ue(t, r, e[r]);

  if (S) for (var r of S(e)) ce.call(e, r) && ue(t, r, e[r]);
  return t;
},
    wt = (t, e) => {
  var r = {};

  for (var o in t) le.call(t, o) && e.indexOf(o) < 0 && (r[o] = t[o]);

  if (t != null && S) for (var o of S(t)) e.indexOf(o) < 0 && ce.call(t, o) && (r[o] = t[o]);
  return r;
};

const yt = _ref3 => {
  let t = _ref3.xhrCallback,
      e = _ref3.fetchCallback,
      r = _ref3.headersToRedact,
      o = _ref3.backendUrl,
      a = _ref3.tracingOrigins,
      c = _ref3.urlBlocklist,
      s = _ref3.sessionSecureID,
      i = _ref3.bodyKeysToRecord,
      n = _ref3.headerKeysToRecord;
  const u = st(d => {
    t(de(d, r, n));
  }, o, a, c, s, i),
        l = ft(d => {
    e(de(d, r, n));
  }, o, a, c, s, i);
  return () => {
    u(), l();
  };
},
      de = (t, e, r) => {
  var o = t,
      a = o.request,
      c = o.response,
      s = wt(o, ["request", "response"]);
  return vt({
    request: et(a, e, r),
    response: tt(c, e, r)
  }, s);
};

var bt = Object.defineProperty,
    Rt = Object.defineProperties,
    Ot = Object.getOwnPropertyDescriptors,
    pe = Object.getOwnPropertySymbols,
    kt = Object.prototype.hasOwnProperty,
    St = Object.prototype.propertyIsEnumerable,
    fe = (t, e, r) => e in t ? bt(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r,
    Et = (t, e) => {
  for (var r in e || (e = {})) kt.call(e, r) && fe(t, r, e[r]);

  if (pe) for (var r of pe(e)) St.call(e, r) && fe(t, r, e[r]);
  return t;
},
    Nt = (t, e) => Rt(t, Ot(e));

class D {
  constructor(e) {
    this.hasNetworkRecording = !0, this.options = e, this.disableConsoleRecording = window.location.hostname === "localhost" || !!e.disableConsoleRecording, this.consoleMethodsToRecord = e.consoleMethodsToRecord || [...ze], this.listeners = [], this.errors = [], this.messages = [];
  }

  isListening() {
    return this.listeners.length > 0;
  }

  startListening() {
    if (this.isListening()) return;
    const e = this;
    this.disableConsoleRecording || this.listeners.push(Be(r => {
      var o, a, c;

      if ((r.type === "Error" || r.type === "error") && r.value && r.trace) {
        const s = K(r.value);
        if (Ge.includes(s) || We.some(i => s.includes(i))) return;
        e.errors.push({
          event: s,
          type: "console.error",
          url: window.location.href,
          source: (o = r.trace[0]) != null && o.fileName ? r.trace[0].fileName : "",
          lineNumber: (a = r.trace[0]) != null && a.lineNumber ? r.trace[0].lineNumber : 0,
          columnNumber: (c = r.trace[0]) != null && c.columnNumber ? r.trace[0].columnNumber : 0,
          stackTrace: r.trace,
          timestamp: new Date().toISOString()
        });
      } else e.messages.push(r);
    }, {
      level: this.consoleMethodsToRecord,
      logger: "console",
      stringifyOptions: {
        depthOfLimit: 10,
        numOfKeysLimit: 100,
        stringLengthLimit: 1e3
      }
    })), this.listeners.push(Me(r => e.errors.push(r))), D.setupNetworkListener(this, this.options);
  }

  stopListening() {
    this.listeners.forEach(e => e()), this.listeners = [];
  }

  static setupNetworkListener(e, r) {
    var o, a, c, s, i, n, u, l;
    e._backendUrl = (r == null ? void 0 : r.backendUrl) || X || "https://pub.highlight.run", e.xhrNetworkContents = [], e.fetchNetworkContents = [], e.networkHeadersToRedact = [], e.urlBlocklist = [], e.tracingOrigins = r.tracingOrigins || [], (r == null ? void 0 : r.disableNetworkRecording) !== void 0 ? (e.disableNetworkRecording = r == null ? void 0 : r.disableNetworkRecording, e.enableRecordingNetworkContents = !1, e.networkHeadersToRedact = [], e.urlBlocklist = [], e.networkBodyKeysToRecord = [], e.networkBodyKeysToRecord = []) : typeof (r == null ? void 0 : r.networkRecording) == "boolean" ? (e.disableNetworkRecording = !r.networkRecording, e.enableRecordingNetworkContents = !1, e.networkHeadersToRedact = [], e.urlBlocklist = []) : (((o = r.networkRecording) == null ? void 0 : o.enabled) !== void 0 ? e.disableNetworkRecording = !r.networkRecording.enabled : e.disableNetworkRecording = !1, e.enableRecordingNetworkContents = ((a = r.networkRecording) == null ? void 0 : a.recordHeadersAndBody) || !1, e.networkHeadersToRedact = ((s = (c = r.networkRecording) == null ? void 0 : c.networkHeadersToRedact) == null ? void 0 : s.map(d => d.toLowerCase())) || [], e.urlBlocklist = ((n = (i = r.networkRecording) == null ? void 0 : i.urlBlocklist) == null ? void 0 : n.map(d => d.toLowerCase())) || [], e.urlBlocklist = [...e.urlBlocklist, ...nt], e.networkHeaderKeysToRecord = (u = r.networkRecording) == null ? void 0 : u.headerKeysToRecord, e.networkHeaderKeysToRecord && (e.networkHeadersToRedact = [], e.networkHeaderKeysToRecord = e.networkHeaderKeysToRecord.map(d => d.toLocaleLowerCase())), e.networkBodyKeysToRecord = (l = r.networkRecording) == null ? void 0 : l.bodyKeysToRecord, e.networkBodyKeysToRecord && (e.networkBodyKeysToRecord = e.networkBodyKeysToRecord.map(d => d.toLocaleLowerCase()))), !e.disableNetworkRecording && e.enableRecordingNetworkContents && e.listeners.push(yt({
      xhrCallback: d => {
        e.xhrNetworkContents.push(d);
      },
      fetchCallback: d => {
        e.fetchNetworkContents.push(d);
      },
      headersToRedact: e.networkHeadersToRedact,
      backendUrl: e._backendUrl,
      tracingOrigins: e.tracingOrigins,
      urlBlocklist: e.urlBlocklist,
      sessionSecureID: r.sessionSecureID,
      headerKeysToRecord: e.networkHeaderKeysToRecord,
      bodyKeysToRecord: e.networkBodyKeysToRecord
    }));
  }

  static getRecordedNetworkResources(e, r) {
    var o;
    let a = [];

    if (!e.disableNetworkRecording) {
      const c = ((o = window == null ? void 0 : window.performance) == null ? void 0 : o.timeOrigin) || 0;
      a = performance.getEntriesByType("resource");
      const s = (r - c) * 2;
      a = a.filter(i => $(i.name, e._backendUrl, e.tracingOrigins)).map(i => Nt(Et({}, i.toJSON()), {
        offsetStartTime: i.startTime - s,
        offsetResponseEnd: i.responseEnd - s,
        offsetFetchStart: i.fetchStart - s
      })), e.enableRecordingNetworkContents && (a = Z(a, e.xhrNetworkContents, "xmlhttprequest"), a = Z(a, e.fetchNetworkContents, "fetch"));
    }

    return a;
  }

  static clearRecordedNetworkResources(e) {
    e.disableNetworkRecording || (e.xhrNetworkContents = [], e.fetchNetworkContents = [], performance.clearResourceTimings());
  }

}

var he = (t => (t.RECORDING_START_TIME = "highlightRecordingStartTime", t.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", t.SESSION_DATA = "sessionData", t.SESSION_SECURE_ID = "sessionSecureID", t.USER_IDENTIFIER = "highlightIdentifier", t.USER_OBJECT = "highlightUserObject", t.PAYLOAD_ID = "payloadId", t))(he || {});

const _t = 1e3 * 55,
      Tt = () => {
  let t = JSON.parse(window.sessionStorage.getItem(he.SESSION_DATA) || "{}");
  if (t && t.lastPushTime && Date.now() - t.lastPushTime < _t) return t;
},
      xt = _ref4 => {
  let t = _ref4.next,
      e = _ref4.payload;

  if (typeof window != "undefined" && typeof document != "undefined" && "H" in window) {
    if (e.obj.type === "track") {
      const r = e.obj.event,
            o = e.obj.properties;
      window.H.track(r, o);
    } else if (e.obj.type === "identify") {
      const r = e.obj.userId;

      if (r != null && r.length) {
        const o = e.obj.traits;
        window.H.identify(r, o);
      }
    }
  }

  t(e);
};

var Lt = xt,
    It = Object.defineProperty,
    Ht = Object.defineProperties,
    Pt = Object.getOwnPropertyDescriptors,
    ge = Object.getOwnPropertySymbols,
    Ct = Object.prototype.hasOwnProperty,
    $t = Object.prototype.propertyIsEnumerable,
    me = (t, e, r) => e in t ? It(t, e, {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: r
}) : t[e] = r,
    E = (t, e) => {
  for (var r in e || (e = {})) Ct.call(e, r) && me(t, r, e[r]);

  if (ge) for (var r of ge(e)) $t.call(e, r) && me(t, r, e[r]);
  return t;
},
    N = (t, e) => Ht(t, Pt(e));

je();

var ve = (t => (t.Device = "Device", t.WebVital = "WebVital", t.Frontend = "Frontend", t.Backend = "Backend", t))(ve || {});

const R = (t, e) => {
  console.warn("Highlight Warning: (".concat(t, "): "), e);
};

var k,
    v,
    _,
    we = !1;

const y = {
  options: void 0,
  init: (t, e) => {
    var r, o, a, c;

    try {
      if (y.options = e, typeof window == "undefined" || typeof document == "undefined") return;

      if (!t) {
        console.info("Highlight is not initializing because projectID was passed undefined.");
        return;
      }

      if (we) return;
      we = !0, k = document.createElement("script");
      var s = e != null && e.scriptUrl ? e.scriptUrl : "https://static.highlight.io/v".concat(q.version, "/index.js");
      k.setAttribute("src", s + "?" + new Date().getMilliseconds()), k.setAttribute("type", "text/javascript"), document.getElementsByTagName("head")[0].appendChild(k);
      let i = Tt(),
          n = De();
      i != null && i.sessionSecureID && (n = i.sessionSecureID);
      const u = {
        organizationID: t,
        debug: e == null ? void 0 : e.debug,
        backendUrl: e == null ? void 0 : e.backendUrl,
        tracingOrigins: e == null ? void 0 : e.tracingOrigins,
        disableNetworkRecording: e == null ? void 0 : e.disableNetworkRecording,
        networkRecording: e == null ? void 0 : e.networkRecording,
        disableConsoleRecording: e == null ? void 0 : e.disableConsoleRecording,
        consoleMethodsToRecord: e == null ? void 0 : e.consoleMethodsToRecord,
        enableSegmentIntegration: e == null ? void 0 : e.enableSegmentIntegration,
        enableStrictPrivacy: (e == null ? void 0 : e.enableStrictPrivacy) || !1,
        enableCanvasRecording: e == null ? void 0 : e.enableCanvasRecording,
        enablePerformanceRecording: e == null ? void 0 : e.enablePerformanceRecording,
        samplingStrategy: e == null ? void 0 : e.samplingStrategy,
        inlineImages: (e == null ? void 0 : e.inlineImages) || !1,
        inlineStylesheet: (e == null ? void 0 : e.inlineStylesheet) || !1,
        firstloadVersion: q.version,
        environment: (e == null ? void 0 : e.environment) || "production",
        appVersion: e == null ? void 0 : e.version,
        sessionShortcut: e == null ? void 0 : e.sessionShortcut,
        feedbackWidget: e == null ? void 0 : e.feedbackWidget,
        sessionSecureID: n
      };
      _ = new D(u), e != null && e.manualStart || _.startListening(), k.addEventListener("load", () => {
        const l = () => {
          v = new window.Highlight(u, _), e != null && e.manualStart || v.initialize();
        };

        if ("Highlight" in window) l();else {
          const d = setInterval(() => {
            "Highlight" in window && (l(), clearInterval(d));
          }, 500);
        }
      }), (o = (r = e == null ? void 0 : e.integrations) == null ? void 0 : r.mixpanel) != null && o.projectToken && Ce(e.integrations.mixpanel), (c = (a = e == null ? void 0 : e.integrations) == null ? void 0 : a.amplitude) != null && c.apiKey && Pe(e.integrations.amplitude);
    } catch (i) {
      R("init", i);
    }
  },
  addSessionFeedback: _ref5 => {
    let t = _ref5.verbatim,
        e = _ref5.userName,
        r = _ref5.userEmail,
        o = _ref5.timestampOverride;

    try {
      y.onHighlightReady(() => v.addSessionFeedback({
        verbatim: t,
        timestamp: o || new Date().toISOString(),
        user_email: r,
        user_name: e
      }));
    } catch (a) {
      R("error", a);
    }
  },
  toggleSessionFeedbackModal: () => {
    try {
      y.onHighlightReady(() => v.toggleFeedbackWidgetVisibility());
    } catch (t) {
      R("error", t);
    }
  },
  consumeError: (t, e, r) => {
    try {
      y.onHighlightReady(() => v.consumeCustomError(t, e, JSON.stringify(r)));
    } catch (o) {
      R("error", o);
    }
  },
  error: (t, e) => {
    try {
      y.onHighlightReady(() => v.pushCustomError(t, JSON.stringify(e)));
    } catch (r) {
      R("error", r);
    }
  },
  track: function (t) {
    let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var r, o, a, c, s, i;

    try {
      y.onHighlightReady(() => v.addProperties(N(E({}, e), {
        event: t
      })));
      const n = v == null ? void 0 : v.getCurrentSessionURL();
      (r = window.mixpanel) != null && r.track && window.mixpanel.track(t, N(E({}, e), {
        highlightSessionURL: n
      })), !!((c = (a = (o = y.options) == null ? void 0 : o.integrations) == null ? void 0 : a.mixpanel) != null && c.projectToken) && !((s = window == null ? void 0 : window.mixpanel) != null && s.track) && console.warn("Mixpanel not loaded, but Highlight is configured to use it. This is usually caused by Mixpanel being blocked by the user's browser."), (i = window.amplitude) != null && i.getInstance && window.amplitude.getInstance().logEvent(t, N(E({}, e), {
        highlightSessionURL: n
      })), window.Intercom && window.Intercom("trackEvent", t, e);
    } catch (n) {
      R("track", n);
    }
  },
  start: t => {
    try {
      if ((v == null ? void 0 : v.state) === "Recording") {
        t != null && t.silent || console.warn("You cannot called `start()` again. The session is already being recorded.");
        return;
      } else {
        _.startListening();

        var e = setInterval(function () {
          v && (clearInterval(e), v.initialize());
        }, 200);
      }
    } catch (r) {
      R("start", r);
    }
  },
  stop: () => {
    try {
      y.onHighlightReady(() => v.stopRecording(!0));
    } catch (t) {
      R("stop", t);
    }
  },
  identify: function (t) {
    let e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var r, o;

    try {
      y.onHighlightReady(() => v.identify(t, e));
    } catch (a) {
      R("identify", a);
    }

    if ((r = window.mixpanel) != null && r.identify && window.mixpanel.identify(t), (o = window.amplitude) != null && o.getInstance && (window.amplitude.getInstance().setUserId(t), Object.keys(e).length > 0)) {
      const a = Object.keys(e).reduce((c, s) => (c.set(s, e[s]), c), new window.amplitude.Identify());
      window.amplitude.getInstance().identify(a);
    }
  },
  metrics: t => {
    try {
      y.onHighlightReady(() => v.recordMetric(t.map(e => N(E({}, e), {
        category: "Frontend"
      }))));
    } catch (e) {
      R("metrics", e);
    }
  },
  getSessionURL: () => new Promise((t, e) => {
    y.onHighlightReady(() => {
      const r = v.getCurrentSessionURL();
      r ? t(r) : e(new Error("Unable to get session URL"));
    });
  }),
  getSessionDetails: () => new Promise((t, e) => {
    y.onHighlightReady(() => {
      const r = v.getCurrentSessionURL();

      if (r) {
        const o = v.getCurrentSessionTimestamp(),
              a = new Date().getTime(),
              c = new URL(r),
              s = new URL(r);
        s.searchParams.set("ts", ((a - o) / 1e3).toString()), t({
          url: c.toString(),
          urlWithTimestamp: s.toString()
        });
      } else e(new Error("Could not get session URL"));
    });
  }),
  onHighlightReady: t => {
    try {
      if (v && v.ready) t();else var e = setInterval(function () {
        v && v.ready && (clearInterval(e), t());
      }, 200);
    } catch (r) {
      R("onHighlightReady", r);
    }
  }
};
typeof window != "undefined" && (window.H = y), He();
export { y as H, Lt as HighlightSegmentMiddleware, ve as MetricCategory, At as configureElectronHighlight };